import { FC } from 'react';
import { DataSource, DataSourceIDEnum } from '@/models/dataSource';
import { CreateDataSourceCodeContent } from './dataSourceTypes/code';
import { CreateDataSourceCrmContent } from './dataSourceTypes/crm';
import { CreateDataSourceFileContent } from './dataSourceTypes/file';
import { CreateDataSourceEmptyContent } from './dataSourceTypes/empty';
import { CreateDataSourceAmazonS3Content } from './dataSourceTypes/amazonS3';
import { CreateDataSourceSFTPContent } from './dataSourceTypes/sftp';
import { CreateDataSourcePluginContent } from './dataSourceTypes/wordpress';

type CreateDataSourceContentProps = {
  dataSourceId: DataSourceIDEnum;
  modalProps?: {
    onSuccess: (dataSource: DataSource) => void;
    onSuccessAndContinue?: (dataSource: DataSource) => void;
    closeModal: VoidFunction;
  };
};

export const CreateDataSourceContent: FC<CreateDataSourceContentProps> = ({ dataSourceId, modalProps }) => {
  const renderSteps = (id: DataSourceIDEnum) => {
    switch (id) {
      case DataSourceIDEnum.WebsiteJS:
      case DataSourceIDEnum.GoogleTagManager:
        return <CreateDataSourceCodeContent dataSourceId={id} modalProps={modalProps} />;
      case DataSourceIDEnum.WordPress:
        return <CreateDataSourcePluginContent dataSourceId={id} modalProps={modalProps} />;
      case DataSourceIDEnum.Salesforce:
        return <CreateDataSourceCrmContent dataSourceId={id} modalProps={modalProps} />;

      case DataSourceIDEnum.CsvFile:
      case DataSourceIDEnum.EncryptedCsvFile:
        return <CreateDataSourceFileContent dataSourceId={id} modalProps={modalProps} />;

      case DataSourceIDEnum.AmazonS3:
        return <CreateDataSourceAmazonS3Content dataSourceId={id} modalProps={modalProps} />;

      case DataSourceIDEnum.SFTP:
        return <CreateDataSourceSFTPContent dataSourceId={id} modalProps={modalProps} />;

      default:
        return <CreateDataSourceEmptyContent dataSourceId={id} />;
    }
  };

  return renderSteps(dataSourceId);
};
